var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSKorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_938_46659)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-7 -3H62V59H-7V-3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20956 19.666L11.1585 10.7459L12.6452 11.7374L6.69624 20.6575L5.20956 19.666ZM7.43958 21.1533L13.3885 12.2332L14.8752 13.2247L8.92627 22.1447L7.43958 21.1533ZM9.66961 22.6405L15.6186 13.7204L17.1052 14.7119L11.1563 23.632L9.66961 22.6405Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9166 41.479L43.8655 32.5589L45.3522 33.5504L39.4033 42.4705L37.9166 41.479ZM40.1466 42.9662L46.0956 34.0462L47.5822 35.0376L41.6333 43.9577L40.1466 42.9662ZM42.3766 44.4535L48.3256 35.5334L49.8123 36.5249L43.8633 45.445L42.3766 44.4535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1477 36.5229L47.5812 41.4804L40.1477 36.5229Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1477 36.5229L47.5812 41.4804",
    stroke: "white",
    strokeWidth: 0.640282
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5908 22.1465C20.1686 19.7807 22.6215 18.1386 25.41 17.5814C28.1985 17.0242 31.0941 17.5976 33.4599 19.1754C35.8257 20.7531 37.4677 23.2061 38.0249 25.9945C38.5821 28.783 38.0088 31.6787 36.431 34.0444L18.5908 22.1465Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5908 22.1463C17.0131 24.5121 16.4397 27.4077 16.9969 30.1962C17.5541 32.9847 19.1962 35.4376 21.562 37.0154C23.9277 38.5931 26.8234 39.1665 29.6118 38.6093C32.4003 38.0521 34.8533 36.41 36.431 34.0442C37.2199 32.8614 37.5066 31.4135 37.228 30.0193C36.9494 28.6251 36.1283 27.3986 34.9455 26.6097C33.7626 25.8208 32.3148 25.5342 30.9205 25.8128C29.5263 26.0913 28.2998 26.9124 27.5109 28.0953L18.5908 22.1463Z",
    fill: "#0047A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5109 28.0954C29.1537 25.6321 28.4886 22.3036 26.0254 20.6608C23.5621 19.0181 20.2336 19.6832 18.5908 22.1464C16.9481 24.6096 17.6132 27.9382 20.0764 29.5809C22.5396 31.2237 25.8682 30.5586 27.5109 28.0954Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1831 45.4473L5.23409 36.5272L6.72078 35.5357L12.6697 44.4558L11.1831 45.4473ZM13.4131 43.96L7.46412 35.0399L8.9508 34.0484L14.8998 42.9685L13.4131 43.96ZM15.6431 42.4728L9.69414 33.5527L11.1808 32.5612L17.1298 41.4813L15.6431 42.4728Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.89 23.6343L37.9411 14.7142L39.4278 13.7227L45.3767 22.6428L43.89 23.6343ZM46.1201 22.147L40.1711 13.2269L41.6578 12.2355L47.6068 21.1555L46.1201 22.147ZM48.3501 20.6598L42.4011 11.7397L43.8878 10.7482L49.8368 19.6683L48.3501 20.6598Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0669 39.748L12.2969 38.2608L10.0669 39.748ZM40.1722 19.6703L42.7739 17.9352L40.1722 19.6703ZM45.0039 16.4479L47.234 14.9607L45.0039 16.4479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0669 39.748L12.2969 38.2608M40.1722 19.6703L42.7739 17.9352M45.0039 16.4479L47.234 14.9607",
    stroke: "white",
    strokeWidth: 0.640282
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_938_46659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSKorea);
export default __webpack_public_path__ + "static/media/s-korea.6e8a7e2c499b0623cc70f8bdc93f1737.svg";
export { ForwardRef as ReactComponent };